export class FormVehiculeModel {
  dateMEC: string;
  yearDateMEC: number;
  marque: string;
  model: string;
  alimentation: string;
  chevaux: number;
  carrosserie: string;
  version: string;
  codeGta: string;
  stationnement: string;
  usage: string;
  codePostalPro: number;
  kilometrage: string;
  financement: string;
  remorque: string;
  isActuellementAssure: string;
  isVehiculeAmenagePMR: string;
  constructor() {}
}
